
export default {
  data() {
    return {
      activeSlide: 0,
      inView: false,
      isEnd: false,
      isBeginning: true,
      options: [
        {
          name: "image",
          label: "Image",
          type: "image",
        },
        {
          name: "title",
          label: "Title",
          type: "text",
        },
        {
          name: "description",
          label: "Description",
          type: "tipTap",
        },
        {
          name: "link",
          label: "Link",
          type: "link",
        },
      ],
    };
  },
  methods: {
    goToSlide(slide) {
      this.activeSlide = slide;
    },
  },
};
